import type { KeyValuePair as SharedKeyValuePair } from "../../lib/normalizeSectionInputs";

export type KeyValuePair = SharedKeyValuePair;

export function convertPairsToObject(pairs: KeyValuePair[]): Record<string, string | number | boolean> {
  const result: Record<string, string | number | boolean> = {};
  pairs.forEach(({ key, value }) => {
    if (value && value?.toString()?.toLowerCase() === "true") {
      result[key] = true;
    } else if (value && value?.toString()?.toLowerCase() === "false") {
      result[key] = false;
    } else {
      result[key] = value;
    }
  });
  return result;
}
